"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var ArticleApi = /** @class */ (function () {
    function ArticleApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 添加文章,查询文章
     * @method POST 添加文章
     * @method GET 查询文章
     *
     */
    ArticleApi.prototype.Article = function () {
        return this.http
            .url("/api/Article")
            .addSecurityHeaders(false)
            .support('POST', 'GET');
    };
    /**
     * 删除文章,更新文章,获取指定Id文章
     * @method DELETE 删除文章
     * @method PUT 更新文章
     * @method GET 获取指定Id文章
     *
     * @params id 无说明
     */
    ArticleApi.prototype.ArticleById = function (id) {
        return this.http
            .url("/api/Article/" + id)
            .addSecurityHeaders(false)
            .support('DELETE', 'PUT', 'GET');
    };
    ArticleApi.diOptions = di_1.default.options({
        name: "ArticleApi",
        scope: "Singleton"
    });
    return ArticleApi;
}());
exports.ArticleApi = ArticleApi;
exports.default = ArticleApi;
